var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar-ctn",style:(_vm.style)},[_c('div',{attrs:{"id":`chartbar2_${_vm.id}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }